export class SubscriptionPurchaseStatus {
  chargeId: number

  status: string

  subscriptionStatus: string

  isApproved: boolean

  constructor(data: Partial<SubscriptionPurchaseStatus> = {}) {
    this.chargeId = data.chargeId ?? 0

    this.status = data.status ?? "pending"

    this.subscriptionStatus = data.subscriptionStatus ?? "pending"

    this.isApproved = data.isApproved ?? false
  }
}
